export enum PaymentSystem {
    Visa = 'visa',
    MasterCard = 'mastercard',
    Mir = 'nspkmir',
}
